function initForms() {

	if (isMobile()) {
		$(".chosen-style").addClass("select-style");
		$(".chosen-style").removeClass("chosen-style");
	}

	$(".formRowSelection").each(function () {
		$(this).find("select").on("change",function () {
			var $frs = $(this).closest(".formRowSelection");
			if ($(this).val() && $(this).val() != "") {
				$frs.find(".formTableBodyMark").show();
			}
			else {
				$frs.find(".formTableBodyMark").hide();
			}
		})
	});

	//update forms on change
	$(".form-field").children("input").change(updateForms);

	//init description icons in select boxes
	$(".descriptionIcon").off().on("mouseover", updateDescription);

	//initialize progress view
	if ($(".progressView").length > 0) {
		updateProgressView();
		$(".progressView").each(function () {
			$(this).find(".progressViewElement").click(updateProgressView);
		});
	}

	if ($(".checkForm").length > 0) {
		initFormCheck();
	}

	/*
	if ($(".showPassword").length > 0) {
		initPasswordHandling();
	}
	*/

	//////////////////////////
	// order form
	if ($("#orderRadioPrivate").length > 0 && $("#orderRadioClub").length > 0) {

		if ($("#orderRadioPrivate").val() == "on") {
			$("#orderRadioPrivate").prop("checked", true);
			switchOrderFormToPrivate();
		}
		else if ($("#orderRadioClub").val() == "on") {
			$("#orderRadioClub").prop("checked", true);
			switchOrderFormToClub();
		}
		else {
			$("#orderRadioPrivate").prop("checked", true);
			switchOrderFormToPrivate();
		}

		$("#orderRadioPrivate").change(switchOrderFormToPrivate);
		$("#orderRadioClub").change(switchOrderFormToClub);
	}

	$(".checkForm").find(".orderSelectboxPrivate").find("select").change(handleOrderSelectChange);
	$(".checkForm").find(".orderSelectboxClub").find("select").change(handleOrderSelectChange);

	//updateForms();

	initNewsSearchReset();

	

}

function initSelectboxes() {
	if ($('.chosen-style').length > 0 || $('.select-style').length > 0) {

		//console.log("InitSelectboxes() chosen-style:" + $('.chosen-style').length + " // select-style:" + $('.select-style').length)

		//initialize select boxes with search field (https://harvesthq.github.io/chosen/)
		$(".chosen-style").find("select").chosen();
		
		//initialize nice select boxes (https://github.com/hernansartorio/jquery-nice-select)
		$(".select-style").find("select").niceSelect();

		//initialize select boxes functionality
		$(".nice-select").each(function () {
			var $ns = $(this);

			$ns.append("<div class='selectOptionDescription'></div>");

			$(this).find(".option").each(function () {
				//find description
				$opt = $ns.siblings("select").find("option[value='" + $(this).attr("data-value") + "']");
				if ($opt.attr("description")) {
					$(this).attr("description", $opt.attr("description"));
				}

				$(this).mouseover(function () {
					if ($(this).attr("description")) {
						$ns.children(".selectOptionDescription").html($(this).attr("description"));
						$ns.children(".selectOptionDescription").show();

						var yPos = Math.round($(this).position().top + $ns.height() - $(this).height() / 2) - 3;
						if ($ns.closest(".select-style").hasClass("small")) {
							yPos = yPos - $(this).height() + 8;
						}
						$ns.children(".selectOptionDescription").css("top", yPos);
					}
				});
				$(this).mouseout(function () {
					if ($(this).attr("description")) {
						$ns.children(".selectOptionDescription").hide();
					}
				});

			});

		});

		$(".select-style").find("select").change(updateForms);
		$(".chosen-style").find("select").change(updateForms);
	}
}

function initPasswordHandling(){
	$(".showPassword").unbind().on("click", function(){
		// show/hide password
		$(this).removeClass("icon-hide");
		if($(this).siblings("input[type=password]").length > 0){
			$(this).siblings("input[type=password]").attr("type", "text");
			$(this).addClass("icon-hide");
		}
		else if($(this).siblings("input[type=text]").length > 0){
			$(this).siblings("input[type=text]").attr("type", "password");
		}
	});
}

var _ff2InputTimeout = null;

function initFormField2(){

	//init formField2 placeholder/labels
	$(".formField2").each(function () {
				
		var $input = $(this).find("input");
		var $textarea = $(this).find("textarea");

		if(!$(this).hasClass("initialized")){
			$(this).addClass("initialized");			

			if($input.length > 0){
				$input.keyup(function(){
					updateFormField2Placeholders();
					
					if(_ff2InputTimeout){
						clearTimeout(_ff2InputTimeout);
					}
					_ff2InputTimeout = setTimeout(updateFormField2Placeholders, 2000);
				});
				$input.change(function(){
					//console.log("handle ff2 input change...");
					updateFormField2Placeholders();
				});
				$input.on("focus", function(){
					//console.log("ff2 input on focus...");
					var $formField = $(this).closest(".formField2");
					var $inputLabel = $formField.find("label");
					if($inputLabel){
						$inputLabel.removeClass("placeholder");
						$formField.removeClass("placeholder-label");
					}
				});
			}
			
			if($textarea.length > 0){
				
				$textarea.on("focus", updateFormField2Placeholders);
				
				$textarea.keyup(function(){
					updateFormField2Placeholders();
					
					if(_ff2InputTimeout){
						clearTimeout(_ff2InputTimeout);
					}
					_ff2InputTimeout = setTimeout(updateFormField2Placeholders, 2000);
				});
				$textarea.change(function(){
					//console.log("handle ff2 input change...");
					updateFormField2Placeholders();
				});
				$textarea.on("focus", function(){
					var $formField = $(this).closest(".formField2");
					var $inputLabel = $formField.find("label");
					if($inputLabel){
						$inputLabel.removeClass("placeholder");
						$formField.removeClass("placeholder-label");
					}
				});
			}
		}
		
		
		
	});
}

function updateFormField2Placeholders(){

	$(".formField2").each(function () {

		var $label = $(this).find("label");
		var $input = $(this).find("input");
		var $textarea = $(this).find("textarea");
		var $select = $(this).find("select");
		var $uiSelect = $(this).find(".ui-select-container");
		var $cb = $(this).find(".checkboxContainer");
		var placeholderAttribute = $input.attr("placeholder");

		if($cb.length > 0){
			return;
		}
		if(placeholderAttribute != undefined && placeholderAttribute != ""){
			return;
		}

		if ($label.length > 0){

			var setPlaceholder = false;
			var setPlaceholderID = 0;
			
			if ($select.length > 0 || $uiSelect.length > 0){
				
				//default selectboxes
				if($select.length > 0 && $select.val() == ""){
					setPlaceholder = true;
					setPlaceholderID = 1;
				}
				
				//itw selectbox
				if($uiSelect.length > 0){
					var $matchText = $(this).find(".ui-select-match-text");
					if($matchText.length > 0 && $matchText.html() == ""){
						setPlaceholder = true;
						setPlaceholderID = 2;
					}
				}
				
				//selectbox with textfield
				var $textField = $(this).children("input[type='text']");
				if ($textField.length > 0){
					if($textField && $textField.val() != ""){
						setPlaceholder = false;
						setPlaceholderID = 3;
					}
				}
				//selectbox with searchfield
				var $searchField = $(this).find("input[type='search']");
				if ($searchField.length > 0){
					if($searchField && $searchField.val() != ""){
						setPlaceholder = false;
						setPlaceholderID = 4;
					}
				}
				
				/*
				if($(this).hasClass("error")){
					setPlaceholder = false;
					setPlaceholderID = 5;
				}
				*/

				if($(this).hasClass("selectTextCombi")){
					var $textField = $(this).children("input[type='text']");
					if($textField.val() == "" && !$textField.is(":focus")){
						setPlaceholder = true;
						setPlaceholderID = 6;	
					}
				}
				
			}
			else if ($input.length > 0){
				if($input.val() == "" && !$input.is(":focus")){
					setPlaceholder = true;
					setPlaceholderID = 7;
				}
			}
			else if ($textarea.length > 0){
				if($textarea.val() == "" && !$textarea.is(":focus")){
					setPlaceholder = true;
					setPlaceholderID = 8;
				}
			}
			else{
				return;
			}

			/*
			console.log("updateFormField2Placeholders()")
			console.log("updateFormField2Placeholders... label:" + $label.html());
			console.log("updateFormField2Placeholders... setPlaceholder:" + setPlaceholder);
			console.log("updateFormField2Placeholders... setPlaceholderID:" + setPlaceholderID);
			console.log("#####");
			*/

			if(setPlaceholder){
				if(!$label.hasClass("placeholder")){
					$label.addClass("placeholder");
					$label.attr("placeholder-id", setPlaceholderID);
				}
				if(!$(this).hasClass("placeholder-label")){
					$(this).addClass("placeholder-label");
				}
			}
			else{
				$label.each(function(){
					$(this).removeClass("placeholder");
					$label.attr("placeholder-id", "");
				});
				$(this).removeClass("placeholder-label");
			}
		}
		
		
	});

	return true;
}

function initDescriptionIconMouseListeners() {

	$(".descriptionIcon").unbind();
	$(".descriptionIcon").mouseover(function () {
		consolog("descriptionIcon mouseover! sib:" + $(this).siblings(".description").length);
		$(this).siblings(".description").addClass('active');
		updateDescription();
	});
	$(".descriptionIcon").mouseout(function () {
		consolog("descriptionIcon mouseout! sib:" + $(this).siblings(".description").length);
		$(this).siblings(".description").removeClass('active');
	});
}


function handleOrderSelectChange() {
	$(".checkForm").find(".orderSelectboxPrivate").removeClass("error");
	$(".checkForm").find(".orderSelectboxClub").removeClass("error");
	$(".orderSelectboxMessage").hide();
}

function scrollToTop() {
	$('html, body').animate({
		scrollTop: 0
	}, 100);
}

function scrollToError() {
	//consolog("scrollToError()");
	if ($(".error:visible").length > 0) {
		//scroll to first error position
		var firstErrorOffset = 0;
		$(".error:visible").each(function () {
			if ($(this).offset().top > 0 && firstErrorOffset == 0) {
				firstErrorOffset = $(this).offset().top;
			}
		});
		firstErrorOffset -= 50;
		if (firstErrorOffset < 0) {
			firstErrorOffset = 0;
		}
		$('html, body').animate({
			scrollTop: firstErrorOffset
		}, 500);
	}
}

function switchOrderFormToPrivate() {
	consolog("private!");

	$("#clubNameRow").hide();
	$("#clubNameRow").find("#inputCompany").removeAttr("required");

	$(".orderSelectboxClub").hide();
	$(".orderSelectboxClub").find("select").val(0);

	$(".orderSelectboxPrivate").show();

	$("#amount1").attr("value", 0);
	$("#amount2").attr("value", 0);
	$("#amount3").attr("value", 0);


	$("#selectboxOrder1a").unbind().change(function () {
		$("#amount1").attr("value", $(this).val());
	});
	$("#selectboxOrder2a").unbind().change(function () {
		$("#amount2").attr("value", $(this).val());
	});
	$("#selectboxOrder3a").unbind().change(function () {
		$("#amount3").attr("value", $(this).val());
	});
}
function switchOrderFormToClub() {
	consolog("club!");

	$("#clubNameRow").show();
	$("#clubNameRow").find("#inputCompany").attr("required", "reduired");

	$(".orderSelectboxPrivate").hide();
	$(".orderSelectboxPrivate").find("select").val(0);

	$(".orderSelectboxClub").show();

	$("#amount1").attr("value", 0);
	$("#amount2").attr("value", 0);
	$("#amount3").attr("value", 0);

	$("#selectboxOrder1b").unbind().change(function () {
		$("#amount1").attr("value", $(this).val());
	});
	$("#selectboxOrder2b").unbind().change(function () {
		$("#amount2").attr("value", $(this).val());
	});
	$("#selectboxOrder3b").unbind().change(function () {
		$("#amount3").attr("value", $(this).val());
	});
}

function updateForms() {

	$(".select-style").find("select").each(function () {
		$(this).parent(".select-style").removeClass("selected");
		if ($(this).val() && $(this).val() != "" && $(this).val() != "0") {
			$(this).parent(".select-style").addClass("selected");
		}
	});

	$(".chosen-style").find("select").each(function () {
		$(this).parent(".chosen-style").removeClass("selected");

		if ($(this).val() && $(this).val() != "" && $(this).val() != "0") {
			$(this).parent(".chosen-style").addClass("selected");
		}
	});

	$(".form-field").children("input").each(function () {

		$(this).removeClass("selected");
		if ($(this).val() && $(this).val() != "" && $(this).val() != "0") {
			$(this).addClass("selected");
		}

	});
}

function updateFormFieldSize() {

	$(".formField").each(function () {
		if ($(this).hasClass("formField2")) {
			//new input, no changes
		}
		else {
			$(this).children("input").each(function () {
				var opts = $(this).parent('.formField').data('height-opt');
				if (opts && opts.exclude) { return; }

				if ($(this).attr("type") == "text") {
					if ($(this).siblings("label").length > 0) {

						//calculate new height
						var h = $(this).siblings("label").innerHeight();
						h = h + Math.round((h / 20) * 10);

						//set new height
						if (h > 0) {
							h = h + 50;
							$(this).css("height", h + "px");
						}

						consolog("updateFormFieldSize() label:" + $(this).siblings("label").html() + " height:" + h);
					}
				}
			});
		}
	});


	$("select-field").each(function () {
		if ($(this).find(".form-field").children("label").length > 0) {
			$(this).find(".form-field").removeClass("large");
			var h = $(this).find(".form-field").children("label").height();

			if (h > 20) {
				$(this).find(".form-field").addClass("large");
			}
		}
	});
}

function updateProgressView() {
	if ($(".progressView").length > 0) {
		$(".progressView").each(function () {

			var label = $(this).find(".progressViewElement.active").find(".progressViewElementLabel").html();
			if ($(this).siblings(".progressViewLabel").length > 0) {
				$(this).siblings(".progressViewLabel").html(label);
			}
		});
	}
}

function initFormCheck() {

	$(".checkForm").each(function () {

		var $form = $(this);

		//reset form fields on change
		if ($form.find("input[type='text']").length > 0) {
			$form.find("input[type='text']").keyup(function () {
				var $ff = $(this).closest(".form-field");
				$ff.removeClass("error");
			});
		}
		if ($form.find("input[type='number']").length > 0) {
			$form.find("input[type='number']").keyup(function () {
				var $ff = $(this).closest(".form-field");
				$ff.removeClass("error");
			});
		}
		if ($form.find("textarea").length > 0) {
			$form.find("textarea").keyup(function () {
				var $ff = $(this).closest(".form-field");
				$ff.removeClass("error");
			});
		}
		if ($form.find("input[type='radio']").length > 0) {
			$form.find("input[type='radio']").change(function () {
				var $ff = $(this).closest(".form-field");
				$ff.removeClass("error");
			});
		}
		if ($form.find("input[type='email']").length > 0) {
			$form.find("input[type='email']").keyup(function () {
				var $ff = $(this).closest(".form-field");
				if (validateEmail($(this).val())) {
					$ff.removeClass("error");
				}
			});
		}
		if ($form.find("input[type='checkbox']").length > 0) {
			$form.find("input[type='checkbox']").change(function () {
				var $ff = $(this).closest(".form-field");
				$ff.removeClass("error");

				if ($(this).closest(".checkboxCheckContainer").length > 0) {
					var $ffs = $(this).closest(".checkboxCheckContainer").find(".form-field")
					$ffs.removeClass("error");
				}
			});
		}
		if ($form.find("input[type='file']").length > 0) {
			$form.find("input[type='file']").change(function () {
				var $ff = $(this).closest(".form-field");
				$ff.removeClass("error");
			});
		}
		if ($form.find("select").length > 0) {
			$form.find("select").change(function () {
				var $ff = $(this).closest(".form-field");
				$ff.removeClass("error");
			});
		}

		//handle submit click
		$form.find(".submitButton").click(function (e) {
			e.preventDefault();

			var err = checkFormErrors($form);

			//submit form if no errors found
			if (err == 0) {
				submitForm($form);
			}
			else {
				window.dispatchEvent(new Event('resize'));
				scrollToError();
			}
		})
	});
}

function submitForm($form){

	//tracking calls
	if ($form.hasClass("salestruckForm")) {
		trackEvent("verkaufswagen_step_conversion", _foodtruckAnnualTotal);
	}
	else if ($form.hasClass("foodtruckForm")) {
		trackEvent("foodtruck_step_conversion", _foodtruckAnnualTotal);
	}

	//disable button and show preloader for 20 seconds
	$form.find(".submitButton").addClass("disabled");
	$form.find(".submitButton").addClass("submitting");
	setTimeout(function(){
		$(".submitButton.submitting").removeClass("disabled").removeClass("submitting");
	},20000);
	
	//submit form
	$form.submit();
}

function checkFormErrors($form){

	var err = 0;

	//check form fields for errors
	$form.find($(".form-field")).each(function () {
		var $ff = $(this);
		$ff.removeClass("error");

		//textfields
		if ($(this).find("input").length > 0) {

			var $input = $(this).find("input");
			$input.removeClass("input-error");

			if (isRequired($input) && $input.val() == "") {
				$ff.addClass("error");
				err++;
			}
			//check email
			else if ($input.val() != "" && $input.hasClass("checkMail") && !validateEmail($input.val())) {
				$ff.addClass("error");
				err++;
			}
			else if ($input.val() != "" && $input.hasClass("checkPostCodeDe") && ($input.val().length !== 5)) {
				$ff.addClass("error");
				err++;
			}
			//check number
			else if ($input.val() != "" && $input.hasClass("checkNumber")) {
				//var numStr = $input.val().replace(/\s+/g, '');
				//$input.val(numStr);

				if (!validatePhone($input.val())) {
					$ff.addClass("error");
					err++;
				}
			}
		}
		//checkboxes
		if ($(this).find("input[type=checkbox]").length > 0) {
			if ($(this).find("input[type=checkbox]").hasClass("formCheckbox") && isRequired($(this).find("input[type=checkbox]")) && !$(this).find("input").is(":checked")) {
				$ff.addClass("error");
				err++;
			}
		}
		//radiobuttons
		if ($(this).find("input[type=radio]").length > 0) {
			var rbChecked = false;
			var rbRequired = false;
			$(this).find("input[type=radio]").each(function(){
				if($(this).is(":checked")){
					rbChecked = true;
				}
				if(isRequired($(this))){
					rbRequired = true;
				}
			});
			if(rbRequired && !rbChecked){
				$ff.addClass("error");
				err++;
			}
			
			/*
			if ($(this).find("input[type=radio]").hasClass("formRadiobutton") && isRequired($(this).find("input[type=radio]")) && !$(this).find("input[type=radio]").is(":checked")) {
				$ff.addClass("error");
				err++;
			}
			*/
		}
		//select boxes
		if ($(this).find("select").length > 0) {
			if (isRequired($(this).find("select")) && $(this).find("select").val() == "") {
				$ff.addClass("error");
				err++;
			}
		}
		//textareas
		if ($(this).find("textarea").length > 0) {
			if (isRequired($(this).find("textarea")) && $(this).find("textarea").val() == "") {
				$ff.addClass("error");
				err++;
			}
		}
	});

	//order form select boxes
	if ($form.find(".orderSelectboxPrivate").length > 0 && $form.find(".orderSelectboxClub").length > 0) {

		var orderCount = 0;
		$form.find(".orderSelectboxPrivate").each(function () {
			$(this).find("select").each(function () {
				if ($(this).val() > 0) {
					orderCount += $(this).val();
				}
			});
		});
		$form.find(".orderSelectboxClub").each(function () {
			$(this).find("select").each(function () {
				if ($(this).val() > 0) {
					orderCount += $(this).val();
				}
			});
		});

		if (orderCount == 0) {
			$form.find(".orderSelectboxPrivate").addClass("error");
			$form.find(".orderSelectboxClub").addClass("error");

			$(".orderSelectboxMessage").show();
			err++;
		}
		else {
			$(".orderSelectboxMessage").hide();
		}
	}

	//checkbox container with >= 1 checkbox needed
	if ($form.find(".checkboxCheckContainer").length > 0) {
		$form.find(".checkboxCheckContainer").each(function () {
			var cbc = 0;
			$(this).find(".formCheckbox").each(function () {
				if ($(this).is(":checked")) {
					cbc++
				}
			});

			if (cbc == 0) {
				$(this).find(".form-field").addClass("error");
				err++;
			}
		});
	}

	//validate min date select boxes
	if ($form.find(".validateMinDate").length > 0) {
		$form.find(".validateMinDate").each(function () {

			var valYear = $(this).find(".selectboxYear").find("select").val();
			var valMonth = $(this).find(".selectboxMonth").find("select").val();
			var valDay = $(this).find(".selectboxDay").find("select").val();

			//consolog("validate MinDate y:" + valYear + " m:" + valMonth + " d:" + valDay);

			if (valYear == "" || valMonth == "" || valDay == "") {
				//minDate val empty!
			}
			else {
				var minDateValue = $(this).attr("data-min-date");
				//consolog("validate MinDate minDateValue:" + minDateValue);

				var minDate = new Date(parseInt(minDateValue.substr(0, 4)), parseInt(minDateValue.substr(4, 2)) - 1, parseInt(minDateValue.substr(6, 2)));
				var selectedDate = new Date(parseInt(valYear), parseInt(valMonth) - 1, parseInt(valDay));

				//consolog("validate MinDate minDate:" + minDate);
				//consolog("validate MinDate selectedDate:" + selectedDate);

				if (minDate.getTime() > selectedDate.getTime()) {
					err++;

					$(this).find(".form-field").addClass("error");
					$(this).find(".errormessage").each(function () {
						$(this).hide();
						if ($(this).hasClass("validateMinDateError")) {
							$(this).show();
						}
					});
				}
			}
		});
	}

		//check captcha
	if($form.find(".frc-captcha").length > 0){
		var $captcha = $form.find(".frc-captcha");
		$captcha.parent(".form-field").removeClass("error");		
		const $captchaInput = $captcha.children("input[type=hidden]");
		if($captchaInput){
			if($captchaInput.val() == ".UNACTIVATED" || $captchaInput.val() == ".ACTIVATED"){
				err++;
				$captcha.parent(".form-field").addClass("error");
			}
		}
	}

	return err;
}

function isRequired($elm) {
	var attr = $elm.attr("required");
	if (typeof attr !== typeof undefined && attr !== false) {
		return true;
	}
	else {
		return false;
	}
}

function validateEmail(value) {
	var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(value);
}
function validatePhone(value) {
	var re = /\(?\d{3}\)?([-\/\.])\d{3}\1\d{4}/;
	return re.test(value);
}


function updateItwSelectboxes(){

	$(".itwWidgetContainer").each(function(){
		$(this).find("select-field").each(function(){
			var $formField = $(this).find(".form-field");
			var $label = $formField.children("label");
			var labelHeight = $label.height();
			var $selectedText = $formField.find(".ui-select-match-text");
			var $btn = $formField.find(".ui-select-match .btn");
			if(labelHeight > 22){
				$selectedText.css("padding-top", (labelHeight+20) + "px");
				$btn.css("min-height", (labelHeight+60) + "px");
			}
			else{
				$selectedText.css("padding-top", "38px");
				$btn.css("min-height", "80px");
			}
		});

	});

}

function initNewsSearchReset(){
	$(".news-search-form__reset").click(function(){
		var $parent = $(this).parent("div");
		if($parent){
			$parent.children("input[type=text]").val("");
		}
	});
}